import Product from "../../../components/product/Product";
import { getData } from "../../../components/product/util";
import { useTranslation } from "react-i18next";

import TableCca from './TableCca';
import TableTap from './TableTap';
import TableRss from './TableRss';

import img1 from 'assets/images/solutions/optimizers/ti/opti_01.png';
import img2 from 'assets/images/solutions/optimizers/ti/opti_02.png';
import img3 from 'assets/images/solutions/optimizers/ti/opti_03.png';
import img4 from 'assets/images/solutions/optimizers/ti/opti_04.png';
import img5_1 from 'assets/images/solutions/optimizers/ti/opti_05.png';
import img5_2 from 'assets/images/solutions/optimizers/ti/opti_05_2.png';
import img6_1 from 'assets/images/solutions/optimizers/ti/opti_06.png';
import img6_2 from 'assets/images/solutions/optimizers/ti/opti_06_2.png';
import img6_3 from 'assets/images/solutions/optimizers/ti/opti_06_3.png';
import img7 from 'assets/images/solutions/optimizers/ti/opti_07.png';
import img7_2 from 'assets/images/solutions/optimizers/ti/opti_07_2.png';

export default function ProductTi(){
  const {t} = useTranslation();
  const products = getData(t, 'optimizers', 'ti');

  // 그림 이름은 대중이 없어서 따로 넣어야 함.
  products[0].images = [img1];
  products[1].images = [img2];
  products[2].images = [img3];
  products[3].images = [img4];
  products[4].images = [img5_1, img5_2];
  products[5].images = [img6_1, img6_2];
  products[6].images = [img7];

    //추가 정보..
    for(let i = 0; i < 7; i++){
      const modelInfo = [];
      const infoCountStr = t(`optimizers.company.ti.products.${i+1}.model-info.count`) ?? 0;
      const infoCount = infoCountStr!==undefined? +infoCountStr: 0;
      for(let j = 1; j < infoCount+1; j++)
        modelInfo.push(t(`optimizers.company.ti.products.${i+1}.model-info.comment-${j}`))
  
      products[i].modelInfo = modelInfo;
    } 

    const imgs=[null,img6_3,img7_2];
    const tables = [<TableCca/>, <TableTap/>, <TableRss/>]
    for(let i=4; i< 7; i++){
      const detailInfo = [];
      const infoCountStr = t(`optimizers.company.ti.products.${i+1}.details.detail-info.count`);
      const infoCount = infoCountStr!==undefined? +infoCountStr: 0;
      for(let j = 1; j < infoCount+1; j++)
        detailInfo.push(t(`optimizers.company.ti.products.${i+1}.details.detail-info.${j}`))

      const details = {
        img:imgs[i-4],
        table:tables[i-4],
        detailInfo
      }
      products[i].details = details;
    }

  return (
    <Product products={products}/>
  );
}